import { Moment } from "moment"
import { calculateElapsedTimeString } from "../../models/sensor"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const elapsedTimeTooltip = (tooltipItems: any, sampleTime: Moment, placementDate: Moment) => {
  const elapsedTimeString = calculateElapsedTimeString(sampleTime, placementDate)
  return `Elapsed Time: ${elapsedTimeString}`
}